import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'
import { NOTIFICATIONS_TABLE_SORT_IMPORTANCE, NOTIFICATIONS_TABLE_SORT_TYPE } from './notifications_table_sort'
import { buildUrl } from '../utils/helpers'

export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST'
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS'
export const GET_NOTIFICATIONS_FAILURE = 'GET_NOTIFICATIONS_FAILURE'

export const GET_ALL_NOTIFICATIONS_REQUEST = 'GET_ALL_NOTIFICATIONS_REQUEST'
export const GET_ALL_NOTIFICATIONS_SUCCESS = 'GET_ALL_NOTIFICATIONS_SUCCESS'
export const GET_ALL_NOTIFICATIONS_FAILURE = 'GET_ALL_NOTIFICATIONS_FAILURE'

export const GET_NOTIFICATION_REQUEST = 'GET_NOTIFICATION_REQUEST'
export const GET_NOTIFICATION_SUCCESS = 'GET_NOTIFICATION_SUCCESS'
export const GET_NOTIFICATION_FAILURE = 'GET_NOTIFICATION_FAILURE'

export const POST_MAKE_READ_REQUEST = 'POST_MAKE_READ_REQUEST'
export const POST_MAKE_READ_SUCCESS = 'POST_MAKE_READ_SUCCESS'
export const POST_MAKE_READ_FAILURE = 'POST_MAKE_READ_FAILURE'

export const POST_MAKE_UNREAD_REQUEST = 'POST_MAKE_UNREAD_REQUEST'
export const POST_MAKE_UNREAD_SUCCESS = 'POST_MAKE_UNREAD_SUCCESS'
export const POST_MAKE_UNREAD_FAILURE = 'POST_MAKE_UNREAD_FAILURE'

export const GET_IMPORTANCE_NOTIFICATIONS_REQUEST = 'GET_IMPORTANCE_NOTIFICATIONS_REQUEST'
export const GET_IMPORTANCE_NOTIFICATIONS_SUCCESS = 'GET_IMPORTANCE_NOTIFICATIONS_SUCCESS'
export const GET_IMPORTANCE_NOTIFICATIONS_FAILURE = 'GET_IMPORTANCE_NOTIFICATIONS_FAILURE'

const buildDataUrl = (page = 1, limit = 25, filter, sortData) => {
  let queryParams = {}

  if (page && limit) {
    const offset = (page - 1) * limit
    queryParams = { ...queryParams, ...{ page, limit, offset } }
  }

  if (filter) {
    const { state, search } = filter
    if (state) {
      if (state === 'unread') {
        queryParams = { ...queryParams, ...{ states: 'delivered,pending' } }
      } else {
        queryParams = { ...queryParams, ...{ states: state } }
      }
    }
    if (search) {
      queryParams = { ...queryParams, ...{ search } }
    }

    if (filter[NOTIFICATIONS_TABLE_SORT_IMPORTANCE]) {
      const importance = filter[NOTIFICATIONS_TABLE_SORT_IMPORTANCE]
      if (importance === 'warning') {
        queryParams = { ...queryParams, ...{ importance: 'warning,critical' } }
      } else {
        queryParams = { ...queryParams, ...{ importance } }
      }
    }

    if (filter[NOTIFICATIONS_TABLE_SORT_TYPE]) {
      const type = filter[NOTIFICATIONS_TABLE_SORT_TYPE]
      queryParams = { ...queryParams, ...{ [NOTIFICATIONS_TABLE_SORT_TYPE]: type } }
    }
  }

  if (sortData) {
    const { field, order } = sortData
    if (field && order) {
      const ordering = order === 'asc' ? field : `-${field}`
      queryParams = { ...queryParams, ...{ ordering } }
    }
  }
  return buildUrl(`/api/notifications/messages-sent/`, {
    ...queryParams,
  })
}

export const getNotifications = (page, limit, filter, sortData) => ({
  [CALL_API]: {
    endpoint: buildDataUrl(page, limit, filter, sortData),
    types: [GET_NOTIFICATIONS_REQUEST, GET_NOTIFICATIONS_SUCCESS, GET_NOTIFICATIONS_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const getImportanceNotifications = (page, limit, sortData) => ({
  [CALL_API]: {
    endpoint: buildDataUrl(page, limit, { [NOTIFICATIONS_TABLE_SORT_IMPORTANCE]: 'warning' }, sortData),
    types: [
      GET_IMPORTANCE_NOTIFICATIONS_REQUEST,
      GET_IMPORTANCE_NOTIFICATIONS_SUCCESS,
      GET_IMPORTANCE_NOTIFICATIONS_FAILURE,
    ],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const getNotification = (id) => ({
  [CALL_API]: {
    endpoint: `/api/notifications/messages-sent/${id}`,
    types: [GET_NOTIFICATION_REQUEST, GET_NOTIFICATION_SUCCESS, GET_NOTIFICATION_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const makeReadNotification = (id) => ({
  [CALL_API]: {
    endpoint: `/api/notifications/messages-sent/${id}/make-read/`,
    types: [POST_MAKE_READ_REQUEST, POST_MAKE_READ_SUCCESS, POST_MAKE_READ_FAILURE],
    method: 'PUT',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const makeUnreadNotification = (id) => ({
  [CALL_API]: {
    endpoint: `/api/notifications/messages-sent/${id}/make-unread/`,
    types: [POST_MAKE_UNREAD_REQUEST, POST_MAKE_UNREAD_SUCCESS, POST_MAKE_UNREAD_FAILURE],
    method: 'PUT',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const getAllNotifications = () => ({
  [CALL_API]: {
    endpoint: `/api/notifications/messages-sent/`,
    types: [GET_ALL_NOTIFICATIONS_REQUEST, GET_ALL_NOTIFICATIONS_SUCCESS, GET_ALL_NOTIFICATIONS_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})
